export default {
  'app.network.offline': '当前处于离线状态，部分功能可能不可用',
  'app.error.chunk.title': '页面加载失败',
  'app.error.chunk.description.offline':
    '网络连接已断开，请检查网络后重新加载。',
  'app.error.chunk.description.online': '页面资源加载失败，请重新加载重试。',
  'app.error.render.title': '页面出现错误',
  'app.error.render.description':
    '抱歉，页面遇到了一些问题，请刷新页面或返回首页。',
  'app.error.retry': '重试',
  'app.error.reload': '刷新页面',
  'app.error.home': '返回首页',
  'app.request.offline': '网络不可用，请检查网络连接后重试。',
};
